<template>
  <div>
    <BlockHeader name="AVG" />
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <DateTime v-model="settingsLocal.scheduleStartDate" type="date" placeholder="Schedule start date" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Checkbox
          v-model="settingsLocal.automaticallySaveShiftLog"
          form-group-id="autoSave"
          placeholder="Automatically save shift log using default values at the end of the day if shift log does not exist"
        />
        <div>
          {{ `Automatically save shift explanation` | i18n }}
        </div>
      </div>
    </div>
    <BlockHeader name="Shift Colors" />
    <div class="row" v-if="colorsLoaded">
      <div v-for="name in shiftNames" :key="name" class="col-lg-6 col-sm-12 col-xs-12" style="margin-bottom: 20px">
        <div>{{ name | i18n }}</div>
        <Chrome v-model="shiftColors[name]" @input="(v) => updateValue(v, name, 'shiftColors')" />
      </div>
    </div>
    <BlockHeader name="Absence Colors" />
    <div class="row" v-if="colorsLoaded">
      <div v-for="name in Object.values(ABSENCE_IS_NOT_PRESENT)" :key="name" class="col-lg-6 col-sm-12 col-xs-12" style="margin-bottom: 20px">
        <div>{{ name | i18n }}</div>
        <Chrome v-model="absenceColors[name]" @input="(v) => updateValue(v, name, 'absenceColors')" />
      </div>
    </div>
  </div>
</template>

<script>
import { Chrome } from 'vue-color';
import Vue from 'vue';

import Input from '../../../common/input/index';
import DateTime from '../../../common/date-time';
import BlockHeader from '../../../common/block-header';
import Checkbox from '../../../common/checkbox/index';
import { ApiMixin } from '../../../../../mixins';
import { ABSENCE_IS_NOT_PRESENT } from '../../../../../../../../constants';

export default {
  name: 'GeneralSettings',
  components: { Input, BlockHeader, DateTime, Chrome, Checkbox },
  mixins: [ApiMixin],
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      shiftNames: ['late', 'night', 'off shift', 'early'],
      shiftColors: {},
      absenceColors: {},
      colorsLoaded: false,
      ABSENCE_IS_NOT_PRESENT: ABSENCE_IS_NOT_PRESENT,
    };
  },
  created() {
    this.shiftNames.forEach((name) => {
      Vue.set(this.shiftColors, name, { rgba: this.settingsLocal.shiftColors[name] });
    });

    Object.values(ABSENCE_IS_NOT_PRESENT).forEach((t) => {
      Vue.set(this.absenceColors, t, { rgba: this.settingsLocal.absenceColors[t] });
    });

    this.colorsLoaded = true;
  },
  computed: {
    settingsLocal: {
      get: function () {
        return this.settings;
      },
      set: function (value) {
        this.$emit('settings', value);
      },
    },
  },
  methods: {
    updateValue(v, name, object) {
      this.settingsLocal[object][name] = `rgba(${v.rgba.r},${v.rgba.g},${v.rgba.b},${v.rgba.a})`;
    },
  },
};
</script>
